module.exports = {
  title: 'Checkbox Form Field',
  context: {
    options: [
      {
        name: 'option 1',
        value: '1'
      },
      {
        name: 'option 2',
        value: '2'
      }
    ]
  }
}
